import { createRoute } from '@tanstack/react-router'
import CollectionsPage from '@/features/collections/pages/CollectionsPage'
import { Route as collectionsRoute } from '../collections'

export const Route = createRoute({
  getParentRoute: () => collectionsRoute,
  path: '/',
  component: CollectionsPage,
})
